import { render, staticRenderFns } from "./ReceivableList.vue?vue&type=template&id=2a60e6e3&lang=pug&"
import script from "./ReceivableList.vue?vue&type=script&lang=ts&"
export * from "./ReceivableList.vue?vue&type=script&lang=ts&"
import style0 from "./ReceivableList.vue?vue&type=style&index=0&id=2a60e6e3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports